import { render, staticRenderFns } from "./FormRO06.vue?vue&type=template&id=d6f05c24"
import script from "./FormRO06.vue?vue&type=script&lang=js"
export * from "./FormRO06.vue?vue&type=script&lang=js"
import style0 from "./FormRO06.vue?vue&type=style&index=0&id=d6f05c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports